export default [
    {
        header: 'Vidéos d\'utilisation',
        module: 'guide',
        profile: ['Admin', 'User', 'Hierarchy','AdminSuper','Technician']
    },
    {
        title: 'Connexion',
        route: 'guide-video-connexion',
        icon: 'FilmIcon',
        module: 'guide',
        profile: ['Admin', 'User', 'Hierarchy','AdminSuper','Technician']
    },
    {
        title: 'Présentation',
        route: 'guide-video-presentation',
        icon: 'FilmIcon',
        module: 'guide',
        profile: ['Admin', 'User', 'Hierarchy','AdminSuper','Technician']
    },
    {
        title: 'Évaluation',
        route: 'guide-video-evaluation',
        icon: 'FilmIcon',
        module: 'guide',
        profile: ['Admin', 'User', 'Hierarchy','AdminSuper','Technician']
    }



]